var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkiWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 5V19",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 17H19",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 5V19",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 17H7",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 6C9.89782 6 10.2794 6.11515 10.5607 6.32013C10.842 6.5251 11 6.8031 11 7.09298V18H8V7.08729C8.00206 6.7984 8.16101 6.52185 8.44209 6.31811C8.72317 6.11437 9.10353 6 9.5 6Z",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9974 6C14.2633 6 14.5183 6.11515 14.7063 6.32013C14.8944 6.5251 15 6.8031 15 7.09298V18H13V7.08729C13 6.79741 13.1056 6.51941 13.2937 6.31443C13.4817 6.10946 13.7122 5.99999 13.9781 5.99999L13.9974 6Z",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11 12.0017C11 11.4485 10.3284 11 9.5 11C8.67157 11 8 11.4485 8 12.0017V12.9983C8 13.5515 8.67157 14 9.5 14C10.3284 14 11 13.5515 11 12.9983V12.0017Z",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15 12.0017C15 11.4485 14.5523 11 14 11C13.4477 11 13 11.4485 13 12.0017V12.9983C13 13.5515 13.4477 14 14 14C14.5523 14 15 13.5515 15 12.9983V12.0017Z",
    stroke: "#fff",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkiWhite);
export default __webpack_public_path__ + "static/media/ski-white.b17acb95709c79d7f3c27a5df102459f.svg";
export { ForwardRef as ReactComponent };